import { Navigate, useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { useEffect, useRef } from 'react';
import { APICore } from '../helpers/api/apiCore';
import { logoutUser } from '../redux/actions';

const PrivateRoute = ({ component: RouteComponent, roles }) => {
    const location = useLocation();
    const dispatch = useDispatch();
    const api = new APICore();

    // Get user from Redux state instead of localStorage
    const reduxUser = useSelector((state) => state.Auth.user);
    const userLoggedIn = useSelector((state) => state.Auth.userLoggedIn);

    // Check token validity using Redux user
    const tokenStatus = reduxUser && reduxUser.token ? api.isUserAuthenticated(reduxUser) : false;
    const hasLoggedOut = useRef(false);

    // Handle token expiration cleanup
    useEffect(() => {
        if (!tokenStatus && reduxUser && !hasLoggedOut.current) {
            hasLoggedOut.current = true;
            dispatch(logoutUser());
        }
    }, [tokenStatus, reduxUser, dispatch]);

    // Public pages that don't require login
    const publicPaths = [
        '/account/login',
        '/account/register',
        '/account/forget-password',
        '/account/reset-password',
        '/account/confirm',
        '/account/lock-screen'
    ];

    // Allow access to public pages without login
    const isPublicPage = publicPaths.some(path => location.pathname.startsWith(path));
    
    // not logged in → redirect to login only for protected pages
    if ((!tokenStatus || !reduxUser) && !isPublicPage) {
        return <Navigate to="/account/login" state={{ from: location }} replace />;
    }

    // For public pages, just pass through
    if (isPublicPage) {
        return <RouteComponent />;
    }

    // check role restriction (only if roles is an array and user exists)
    if (roles && reduxUser && !roles.includes(reduxUser.role)) {
        return <Navigate to="/" replace />;
    }

    return <RouteComponent />;
};

export default PrivateRoute;
